import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';

const EasilyScabable: React.FC = () => {
    const { t } = useLang('EasilyScabable');

    const items: string[] = [t('text1'), t('text2'), t('text3'), t('text4')];

    return (
        <div className={`${styles.EasilyScabable} easily-scabable GtmModuleData-section`} id="EasilyScabable" data-section-id="d3m-easily-scabable">
            <div className="img">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1772445682762/series.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1772447196268/series_m.jpg"
                />
            </div>
            <p className="title">{t('title')}</p>
            <ul className="items">
                {items?.map((item: string, k: number) => (
                    <li className={`item item-${k + 1}`} key={item}>
                        {item}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default EasilyScabable;
